import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry, map } from 'rxjs/operators';

import { ENPOINT } from '../endpoint';
import { Options } from 'selenium-webdriver/safari';

import { GLOBAL } from '../global';

@Injectable()
export class CatalogsService {

  constructor(
    private http: HttpClient,
    
  ) { }
  public url = GLOBAL.url;
  private basePath = ENPOINT.url;

  obtenerProveedores(): Observable<any> {
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true
    }
    return this.http.get(this.basePath +
       'catalog/obtener-proveedores', options);
  }

  obtenerProveedoresBusqueda(value): Observable<any> {    
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('value', value)
        };
    return this.http.get<any>(this.basePath +
       'catalog/obtener-proveedores', options)
       .pipe(
        map(rsp => rsp.sapProveedor),
        retry(3)
      );
  }

  obtenerSociedades(): Observable<any> {
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set("Access-Control-Allow-Origin", "*") 
        .set("SameSite", 'None'),
      withCredentials: true
        };
    return this.http.get(this.basePath +
       'catalog/obtener-sociedades', options);
  }

  obtenerMonedaPorModulo(modulo): Observable<any> {
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('modulo', modulo)
    };
    return this.http.get(this.basePath + 'moneda/obtener-moneda-por-modulo', options);
  }


  crearMonedas(datos: any, tipo: string): Observable<any> {

    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json'  });
    let url;

   if (tipo === 'moneda'){
   url = 'moneda/insertar-moneda' ;
   const options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'  }),
    withCredentials: true,
    params: new HttpParams()
    .set('descripcionMoneda', datos.identificador)
    .set('codigoMoneda', datos.codigo)
    .set('modulo', 'P')

      };
      return this.http.post(this.basePath +
        url, '' , options);
   } else {
   let urlhm = 'homologacion-moneda/insertar-hm';
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'  }),
      withCredentials: true,
      params: new HttpParams()
      .set('descripcionMoneda', datos.identificador)
      .set('hMoneda', datos.codigo)
        };
        return this.http.post(this.basePath +
          urlhm, '', options);
   }


  }


  listarMonedas(): Observable<any> {
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json'  });
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('modulo', 'P')
        };
    return this.http.get(this.basePath +
       'moneda/obtener-moneda-por-modulo', options);
  }

  listarHomologacion(): Observable<any> {
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json'  });
    const options = {
      headers: httpHeaders,
      withCredentials: true,
     
        };
    return this.http.get(this.basePath +
       'homologacion-moneda/obtener-hm', options);
  }


  eliminarHomologacion(id: string): Observable<any> {
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json'  });
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('idHomologacion', id)
        };
    return this.http.get(this.basePath +
       'homologacion-moneda/borrar-hm', options);
  }


  eliminarMoneda(id: string): Observable<any> {
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json'  });
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('idMoneda', id)
        };
    return this.http.get(this.basePath +
       'moneda/borrar-moneda', options);
  }

 /* obtenerCuentaDeMayor(value): Observable<any> {
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('value', value)
    };
    return this.http.get(this.basePath +
       'catalog/obtener-cuentasm', options);
  } */

  obtenerCuentaDeMayor(value): Observable<any> {
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('value', value)
        };
    return this.http.get<any>(this.basePath +
       'catalog/obtener-cuentasm', options)
       .pipe(
        map(rsp => rsp.sapCuentasm),
        retry(3)
      );
  }

  /*
  obtenerCecos(value): Observable<any> {
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json'  });
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('value', value)
    };
    return this.http.get(this.basePath +
       'catalog/obtener-cecos', options);
  } */

  obtenerCecos(value): Observable<any> {
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('value', value)
        };
    return this.http.get<any>(this.basePath +
       'catalog/obtener-cecos', options)
       .pipe(
        map(rsp => rsp.sapCosto),
        retry(3)
      );
  }

  obtenerIndicadoresIva(): Observable<any> {
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json'  });
    const options = {
      headers: httpHeaders,
      withCredentials: true
    };
    return this.http.get(this.basePath +
       'Proveedores/indicadoresIva', options);
  }




}



// WEBPACK FOOTER //
// ./src/app/services/catalogs/catalogs.service.ts